import description from './description';

export default {
  groupId: 'diagnosis',
  groupName: 'encounter:widget.diagnosis.description',
  widgets: { [description.id]: description }
};
